import { ExerciseTestCaseType } from "@/models";

export const icons = {
	[ExerciseTestCaseType.SHOW_TEXT_ONLY]: ["code_off-sm"],
	[ExerciseTestCaseType.SHOW_CODE_SHOW_TEXT]: ["public-sm"],
	[ExerciseTestCaseType.HIDDEN]: ["visibility_off-sm"],
};
